import Signup from './Signup.vue';

export default Signup;
